import { createReducer, on } from "@ngrx/store";
import { InitialSharedState, InitialSharedStateGetCulture } from "../states/shared.state";
import { addRouteToHistory, getCountryCulture, getUserProfile, resetAppStateAction, updateUserName } from "../actions/shared.action";
import { updateLogOutData } from "../actions/static.actions";
export const initialHistoryState: string[] = [];

export const sharedReducer = createReducer(InitialSharedState,
    on(getUserProfile.loadUserProfile, (state, payload) => {
        switch (payload.status) {
            case 'request':
                return { ...state, loading: true };
            case 'success':
                const userData = payload?.data?.data?.[0] || payload?.data
                return { ...state, loading: false, userProfile: userData, success: true, };
            case 'failure':
                return { ...state, loading: false };
            default:
                return state;
        }
    }),
      on(updateUserName, (state, { firstName, lastName }) => ({
    ...state,
    userProfile: {
      ...state.userProfile,
      firstName,
      lastName
    }
  })),
  on(updateLogOutData, (state, {data}) =>({
    ...state,
      userProfile: {
      panelistId: null,
    }
    })),
    on(resetAppStateAction, () => InitialSharedState),
)
export const cultureReducer = createReducer(InitialSharedStateGetCulture,
    on(getCountryCulture.loadCountryCulture, (state, payload) => {
        switch (payload.status) {
            case 'request':
                return { ...state, loading: true };
            case 'success':
                const culture = payload?.data
                return { ...state, loading: false, culture, success: true, message: 'Culture get Success' };
            case 'failure':
                return { ...state, loading: false };
            default:
                return state;
        }
    }),
)
const initialState = {
  // initial user state
};
export const userReducer = createReducer(
  initialState,
  // Regular reducers...
  
  // Reset on specific action OR global reset
  on(resetAppStateAction, resetAppStateAction, () => initialState)
);

export const routerHistoryReducer = createReducer(
  initialHistoryState,
  on(addRouteToHistory, (state, { url }) => [...state, url])
);
